import formInputComponents from './inputs'

const formComponents = [...formInputComponents]

export default formComponents
